<template>
  <div class="news-detail-view">
    <section class="site-hero news-detail-hero">
      <div class="site-hero__inner">
        <div class="crumb-row">
          <router-link class="crumb-link" to="/news">返回企业动态</router-link>
        </div>
        <!-- <span v-if="news" class="site-hero__eyebrow">{{ news.category }}</span> -->
        <h1>{{ news ? news.title : "企业动态详情" }}</h1>
        <!-- <p>{{ news ? news.summary : "查看企业动态详情内容。" }}</p> -->
      </div>
    </section>

    <section class="page-section detail-section">
      <div class="page-shell">
        <el-empty v-if="!news" description="未找到对应企业动态，请返回列表重新选择。" />
        <div v-else class="detail-layout">
          <article class="panel-card article-card">
            <div class="article-cover">
              <img :src="news.image" :alt="news.title">
            </div>
            <div class="article-meta">
              <span>{{ news.category }}</span>
              <time>{{ news.date }}</time>
            </div>
            <h2>{{ news.title }}</h2>
            <p v-for="paragraph in news.content" :key="paragraph">{{ paragraph }}</p>
          </article>

          <aside class="side-group">
            <article class="panel-card side-card">
              <h3>动态标签</h3>
              <div class="tag-list">
                <span v-for="tag in news.tags" :key="tag">{{ tag }}</span>
              </div>
            </article>
            <article class="panel-card side-card">
              <h3>其他动态</h3>
              <div class="related-list">
                <a
                  v-for="item in relatedNews"
                  :key="item.id"
                  class="related-item"
                  :href="resolveNewsHref(item)"
                  :target="item.articleUrl ? '_blank' : null"
                  :rel="item.articleUrl ? 'noopener' : null"
                  @click="handleNewsClick($event, item)"
                >
                  {{ item.title }}
                </a>
              </div>
            </article>
          </aside>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { getNews, getNewsDetail } from "@/api/website";

export default {
  name: "NewsDetailView",
  data() {
    return {
      news: null,
      relatedNews: []
    };
  },
  computed: {
    newsId() {
      return this.$route.query.id;
    }
  },
  watch: {
    newsId: "loadNews"
  },
  created() {
    this.loadNews();
  },
  methods: {
    loadNews() {
      if (!this.newsId) {
        this.news = null;
        return;
      }
      getNewsDetail(this.newsId).then((res) => {
        this.news = res.data || null;
      });
      getNews({ pageNo: 1, pageSize: 6 }).then((res) => {
        const data = res.data || {};
        this.relatedNews = (data.records || []).filter((item) => item.id !== this.newsId);
      });
    },
    resolveNewsHref(item) {
      if (item.articleUrl) {
        return this.normalizeExternalUrl(item.articleUrl);
      }
      return this.$router.resolve({ path: "/news-detail", query: { id: item.id } }).href;
    },
    normalizeExternalUrl(url) {
      const trimmedUrl = String(url || "").trim();
      if (/^[a-z][a-z0-9+.-]*:/i.test(trimmedUrl) || trimmedUrl.startsWith("//")) {
        return trimmedUrl;
      }
      return `https://${trimmedUrl}`;
    },
    handleNewsClick(event, item) {
      if (item.articleUrl) {
        return;
      }
      event.preventDefault();
      this.$router.push({ path: "/news-detail", query: { id: item.id } });
    }
  }
};
</script>

<style lang="less" scoped>
.news-detail-hero {
  background:
    linear-gradient(90deg, rgba(3, 23, 50, 0.94) 0%, rgba(7, 55, 105, 0.74) 48%, rgba(12, 83, 146, 0.34) 100%),
    url("/assets/banner.png") center / cover no-repeat;
}

.detail-section {
  background: var(--soft-blue);
}

.page-shell {
  width: min(1280px, 100%);
  margin: 0 auto;
}

.crumb-row {
  margin-bottom: 22px;
}

.crumb-link {
  display: inline-flex;
  min-height: 38px;
  align-items: center;
  padding: 0 16px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.22);
  color: var(--white);
}

.detail-layout {
  display: grid;
  grid-template-columns: minmax(0, 0.72fr) minmax(280px, 0.28fr);
  gap: 22px;
}

.article-card {
  padding: clamp(22px, 4vw, 34px);
}

.article-cover {
  aspect-ratio: 16 / 8;
  margin-bottom: 24px;
  border-radius: 10px;
  overflow: hidden;
  background: #f5f9ff;
}

.article-cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.article-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  color: var(--blue);
  font-size: 13px;
  font-weight: 900;
}

.article-meta time {
  color: var(--muted);
}

.article-card h2 {
  margin: 12px 0 18px;
  font-size: clamp(28px, 4vw, 46px);
  line-height: 1.18;
}

.article-card p {
  margin: 0;
  color: #44536b;
  font-size: 16px;
}

.article-card p + p {
  margin-top: 16px;
}

.side-group {
  display: grid;
  align-content: start;
  gap: 18px;
}

.side-card {
  padding: 24px;
}

.side-card h3 {
  margin: 0 0 14px;
  font-size: 22px;
}

.related-list {
  display: grid;
  gap: 10px;
}

.related-item {
  display: block;
  padding: 12px 14px;
  border-radius: 10px;
  background: #f5f9ff;
  color: var(--navy);
  font-weight: 700;
}

@media (max-width: 1040px) {
  .detail-layout {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 680px) {
  .crumb-link {
    min-height: 34px;
    padding: 0 12px;
    font-size: 13px;
  }

  .article-card {
    padding: 20px;
  }

  .article-card h2 {
    font-size: 24px;
  }

  .article-card p,
  .related-item {
    font-size: 14px;
  }

  .side-card {
    padding: 20px;
  }

  .side-card h3 {
    font-size: 20px;
  }
}
</style>
